/* eslint-disable no-redeclare */
import React from 'react'
import _ from 'common-tools/LodashHelper'
const uuidv4 = require('uuid/v4')

export function BuildTransitionPath (uri, pathname, key = uuidv4(), maxSegments = 1) {
  let testUrl = pathname
  testUrl = _.replace(testUrl, uri, '')
  const testURLParts = testUrl.split('/')
  if (maxSegments > 0) {
    var path = `${key}-${_.join(_.take(_.filter(testURLParts, (v) => { return v !== '' }), maxSegments), '-')}`
  } else {
    var path = `${key}-${testUrl}`
  }
  return path
}

export function TransitionPathWrapper (options) {
  let internalWrapper = (lopts) => {
    return (WrappedComponent) => {
      let opts = _.merge({
        key: undefined,
        maxSegments: 1
      }, lopts)

      if (!opts.key) {
        opts.key = uuidv4()
      }

      class TransitionPathInternal extends React.Component {
        ref = null

        getWrappedInstance () {
          return this.ref
        }

        render () {
          const { uri, location } = this.props

          const path = BuildTransitionPath(uri, location.pathname, opts.key, opts.maxSegments)

          return (
            <WrappedComponent ref={(c) => { this.ref = c }} {...this.props} TransitionPath={path} />
          )
        }
      }

      return TransitionPathInternal
    }
  }

  if (_.isFunction(options)) {
    return internalWrapper({})(options)
  }

  return internalWrapper(options)
}
